import { Prompt } from '../../../types';
import { extractVariables } from '../../../utils/variables';

export const handlePromptAction = async (
  prompt: Prompt,
  onShowVariableForm: (
    prompt: Prompt,
    variables: string[],
    actionType?: 'copy' | 'openInChatGPT'
  ) => void,
  onCopyToClipboard: (text: string) => void,
  onSelectPrompt: (prompt: Prompt) => void
) => {
  // Add defensive check for prompt and prompt.text
  if (!prompt || typeof prompt.text !== 'string') {
    console.error('handlePromptAction called with invalid prompt:', prompt);
    return;
  }

  console.log('handlePromptAction: Processing prompt with text:', prompt.text);
  const vars = extractVariables(prompt.text);
  if (vars.length > 0) {
    onShowVariableForm(prompt, vars, 'copy');
  } else {
    await onCopyToClipboard(prompt.text);
    onSelectPrompt(prompt);
  }
};

export const handleOpenInChatGPT = async (
  prompt: Prompt,
  onShowVariableForm: (
    prompt: Prompt,
    variables: string[],
    actionType?: 'copy' | 'openInChatGPT'
  ) => void
) => {
  // Add defensive check for prompt and prompt.text
  if (!prompt || typeof prompt.text !== 'string') {
    console.error('handleOpenInChatGPT called with invalid prompt:', prompt);
    return;
  }

  console.log('handleOpenInChatGPT: Processing prompt with text:', prompt.text);
  const vars = extractVariables(prompt.text);
  if (vars.length > 0) {
    onShowVariableForm(prompt, vars, 'openInChatGPT');
  } else {
    const encodedPrompt = encodeURIComponent(prompt.text);
    window.open(`https://chat.openai.com/?model=gpt-4&q=${encodedPrompt}`, '_blank');
  }
};
